import { render, staticRenderFns } from "./JgpDiv.vue?vue&type=template&id=732ccf0d&"
import script from "./JgpDiv.vue?vue&type=script&lang=js&"
export * from "./JgpDiv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports